import { Directive, HostListener, ElementRef, OnInit } from "@angular/core";

@Directive({ selector: "[onlyCurrency]" })
export class OnlyCurrencyDirective
{
    private el: HTMLInputElement;
    private valor: number;

    constructor( private elementRef: ElementRef ) {
        this.el = this.elementRef.nativeElement;
    }

    ngOnInit()
    {
        this.el.style.borderColor = '#BDBDBD';
        this.el.style.backgroundColor = '#fff';
        this.el.style.background = '#fff';
        this.el.style.color = '#555';
        this.el.style.border = '1px solid #BDBDBD';
    }

    format(comma, period)
    {
        comma = comma || ',';
        period = period || '.';
        var split = this.toString().split('.');
        var numeric = split[0];
        var decimal = split.length > 1 ? period + split[1] : '';
        var reg = /(\d+)(\d{3})/;
        while (reg.test(numeric))
        {
            numeric = numeric.replace(reg, '$1' + comma + '$2');
        }
        return numeric + decimal;
    }



    @HostListener("blur", ["$event.target.value"])
    onBlur(value) {

        if(value.trim()=="" || value=="0" || value==0 || isNaN(parseInt(value, 10)) )
        {
            this.el.value = "";
            value = "";
        }
        else
        {
            this.elementRef.nativeElement.style.backgroundColor = '#f0fff0';
            this.elementRef.nativeElement.style.borderColor = '#7DC27D';
            let value0 = value.split(',').join("");
            let value2 = parseFloat(value0);
            this.el.value = value2.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
            //this.el.value = value2.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");   || isNaN(value)==true
        }
        this.el.style.borderColor = '#BDBDBD';
        this.el.style.backgroundColor = '#fff';
        this.el.style.background = '#fff';
        this.el.style.color = '#555';
        this.el.style.border = '1px solid #BDBDBD';
    }




    /* Cuando presiono tecla */
    @HostListener("keyup", ["$event.target.value"])
    onKeyup(value) {
            value = value.trim();
            value = value.replace(/[^0-9.]*/gi, "");
            if(value.trim()=="" || value=="0" || value==0 || isNaN(parseInt(value, 10)) )
            {
                this.el.value = "";
                value = "";
            }


        setTimeout(() => {
            var patt = new RegExp('^[0-9.]+$');
            if((patt.test(value))==false)
            {
                this.el.value = value.replace(/[^0-9.]*/gi, "");
            }
            else
            {
                this.elementRef.nativeElement.style.backgroundColor = '#f0fff0';
                this.elementRef.nativeElement.style.borderColor = '#7DC27D';
            }
            this.el.value = this.format.call(value.split(',').join(''),',','.');

            this.el.style.borderColor = '#BDBDBD';
            this.el.style.backgroundColor = '#fff';
            this.el.style.background = '#fff';
            this.el.style.color = '#555';
            this.el.style.border = '1px solid #BDBDBD';
        }, 50);
    }





}


// WEBPACK FOOTER //
// ./src/app/shared/utils/directives/onlyCurrency.directive.ts